module.exports = __webpack_public_path__ + "img/rewards-active.a55335f8.svg";